import "./chatBot.css";
import { ReactComponent as ChatBotIcon } from "../../assets/chatbot.svg";
import { ReactComponent as RightArrow } from "../../assets/arrow-icon.svg";
import { ReactComponent as FilterIcon } from "../../assets/filter-icon.svg";
import { ReactComponent as FilterIconFilled } from "../../assets/filter-icon-filled.svg";
import { ReactComponent as DocumentSmall } from "../../assets/file-icon-small.svg";
import { useState } from "react";
import { chatBotAI } from "../../services";
import ReactMarkdown from "react-markdown";
import DOMPurify from "dompurify";
import { CategoryFocusButton } from "./components/categoryFocusButton";

const ChatBot = ({ categories }) => {
  const [filterPanelOpen, setFilterPanelOpen] = useState(false);
  const [submittedQuestionFlag, setSubmittedQuestionFlag] = useState(false);
  const [showResponse, setShowResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typedQuestion, setTypedQuestion] = useState("");
  const [givenQuestion, setGivenQuestion] = useState("");
  const [threadId, setThreadId] = useState(null);
  const [answer, setAnswer] = useState("");

  const sendQuestion = async question => {
    setLoading(question ? true : false);
    setAnswer('');
    if (question) {
      setSubmittedQuestionFlag(true);
      chatBotAI({message: question, threadId: threadId}).then((res) => {
      setAnswer(res?.answer); 
      setThreadId(res?.threadId);
      setShowResponse(true);
      setLoading(false);
    }).catch((err) => console.error(err));
  }
    // console.log({response})
    // setShowResponse(true)
  };

  const restartConvo = () => {
    setThreadId(null);
    setAnswer("");
    setTypedQuestion("");
    setGivenQuestion(false);
    setShowResponse(false);
    setSubmittedQuestionFlag(false);
    setFilterPanelOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div id="chat-bot-wrapper">
      <div id="chat-bot-header">
        <div id="icon">
          <ChatBotIcon className={loading ? "loading" : ""} />
        </div>
        <div id="title" className={loading ? "loading" : ""}>
          <div id="bot-header-title" className="header-title">
            {loading ? "Looking for your answer!" : "Ask the Purples"}
          </div>
          <div id="bot-subheader-title" className="header-title">
            {loading ? "Please be patient" : "Your Virtual Assistant"}
          </div>
        </div>
      </div>
      <div id="chat-bot-body">
        <div id="question-panel">
          {!submittedQuestionFlag && (
            <div id="open-question">
              <textarea
                id="question-input"
                className="custom-scroll"
                wrap="soft"
                placeholder="Ask the Purples anything..."
                value={typedQuestion}
                onChange={e => setTypedQuestion(e.target.value)}
              />
              <button
                id="submit-button"
                onClick={() => {
                  setGivenQuestion(typedQuestion);
                  sendQuestion(typedQuestion);
                  setTypedQuestion("");
                }}
              >
                <RightArrow />
              </button>
            </div>
          )}
          {submittedQuestionFlag && (
            <div id="question-presentation">
              <p className="main-text">
                <span className="boldPurple16">You: </span>
                {givenQuestion}
              </p>
            </div>
          )}
        </div>
        <div id="focus">
          <button
            id="focus-button"
            onClick={() => setFilterPanelOpen(!filterPanelOpen)}
          >
            {filterPanelOpen ? <FilterIconFilled /> : <FilterIcon />}
            <span className="boldPurple16">Focus</span>
          </button>
          <div
            id="focus-panel"
            className={`${filterPanelOpen ? "visible" : "hidden"}`}
          >
            <div id="focus-title">
              <DocumentSmall />
              Regulatory Universe
            </div>
            <div id="focus-options">
              {categories?.map(cat => {
                return cat.value !== "Other" ? (
                  <CategoryFocusButton key={cat.value} category={cat}/>
                ) : null;
              })}
            </div>
          </div>
        </div>
        {submittedQuestionFlag && showResponse && answer && (
          <div id="response">
            <p className="boldPurple16">Answer</p>
            <p className="main-text">
              {/* Render as Markdown */}
              <ReactMarkdown>{DOMPurify.sanitize(answer)}</ReactMarkdown>
            </p>
            <p className="main-text">
              Disclaimer: Το παραπάνω αποτελεί γενική πληροφορία, και όχι γενική
              συμβουλή.
            </p>
          </div>
        )}
        {submittedQuestionFlag && (
          <div id="new-question">
            <button id="new-conversation-btn" disabled={loading} onClick={() => restartConvo()}><span>New Converasion</span><span id="right-icon">{">"}</span></button>
            <div id="open-question">
              <textarea
                id="question-input"
                disabled={loading}
                className="custom-scroll"
                wrap="soft"
                placeholder="Ask a follow up question..."
                value={typedQuestion}
                onChange={e => setTypedQuestion(e.target.value)}
              />
              <button
                id="submit-button"
                disabled={loading}
                onClick={() => {
                  setGivenQuestion(typedQuestion);
                  sendQuestion(typedQuestion, threadId);
                  setTypedQuestion("");
                }}
              >
                <RightArrow />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatBot;
